import { Firm } from '../_classes/list/firm';

export let Firms: Firm[] = [
  {
    id: 1,
    firm_id: null,
    firm: null,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'МКУ «Социальный дом ветеранов»'
  },
  {
    id: 2,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 1,
    territory: 'Челябинск',
    name: 'КСП города Челябинска'
  },
  {
    id: 3,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 2,
    territory: 'Челябинск, Калининский район',
    name: 'МБУ «КЦСОН по Калининскому району города Челябинска»'
  },
  {
    id: 4,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 3,
    territory: 'Челябинск, Курчатовский район',
    name: 'МБУ «КЦСОН по Курчатовскому району города Челябинска»'
  },
  {
    id: 5,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 4,
    territory: 'Челябинск, Ленинский район', 
    name: 'МБУ «КЦСОН по Ленинскому району города Челябинска»'
  },
  {
    id: 6,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 5,
    territory: 'Челябинск, Металлургический район',
    name: 'МБУ «КЦСОН по Металлургическому району города Челябинска»'
  },
  {
    id: 7,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 6,
    territory: 'Челябинск, Советский район',
    name: 'МБУ «КЦСОН по Советскому району города Челябинска»'
  },
  {
    id: 8,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 7,
    territory: 'Челябинск, Тракторозаводский район',
    name: 'МБУ «КЦСОН по Тракторозаводскому району города Челябинска»'
  },
  {
    id: 9,
    firm_id: 1,
    firm: 'МКУ «Социальный дом ветеранов»',
    territory_id: 8,
    territory: 'Челябинск, Центральный район',
    name: 'МБУ «КЦСОН по Центральному району города Челябинска»'
  }
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/firms.ts